const qualities = [
  { label: "No pressure to perform" },
  { label: "No prescriptive advice" },
  { label: "No judgement" },
  { label: "No agenda" },
];

export default function Experience() {
  return (
    <section id="experience" className="bg-white py-28 md:py-36 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">

        {/* Top label */}
        <p className="font-sans text-xs tracking-widest2 uppercase text-ink mb-6 text-center">
          The Experience
        </p>

        <h2 className="font-serif text-4xl md:text-5xl font-light text-ink text-center leading-snug mb-8 max-w-3xl mx-auto">
          Where Vision Meets Wisdom
        </h2>

        <p className="font-sans text-base font-light text-ink text-center leading-relaxed max-w-lg mx-auto mb-20">
          Our session together is an intentional, necessary pause in a world full of loud advice. A space to step back and reconnect with your own internal signal. From there, you begin to move beyond the noise and into what's actually true for you.
        </p>

        {/* Main Experience block */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0 border border-sand/50">

          {/* Photo panel */}
          <div className="lg:col-span-2 overflow-hidden" style={{ minHeight: "400px" }}>
            <img
              src="https://public.readdy.ai/ai/img_res/9b9a8f8f251eb19570101942765124d1.jpg"
              alt="Calm, grounded coaching space"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: "400px" }}
            />
          </div>

          {/* Content panel */}
          <div className="lg:col-span-3 bg-cream p-10 md:p-14 flex flex-col justify-center">
            <p className="font-serif text-xl md:text-2xl font-light text-ink leading-relaxed mb-10">
              You arrive as you are. There&apos;s no agenda to push, no personality framework to assign, no homework to complete. Just a clear, unhurried session to think out loud with someone who will meet you where you are.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {qualities.map((q) => (
                <div key={q.label} className="flex items-center gap-3">
                  <div className="w-4 h-px bg-ink shrink-0" />
                  <span className="font-sans text-sm text-ink">{q.label}</span>
                </div>
              ))}
            </div>

            <div className="border-t border-sand pt-8">
              <p className="font-serif text-lg italic text-ink leading-relaxed">
                &ldquo;My role is not to tell you what to do. It&apos;s to help you hear yourself think — and trust what you hear.&rdquo;
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
